import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { message: string | null };

/**
 * Une exception pendant le rendu démonte tout l'arbre React et laisse une page
 * blanche, sans le moindre indice pour l'utilisateur. Ce garde-fou affiche à la
 * place un message lisible et le détail technique, pour qu'une régression reste
 * diagnosticable sans ouvrir la console du navigateur.
 */
export class ErrorBoundary extends Component<Props, State> {
  public override state: State = { message: null };

  public static getDerivedStateFromError(error: unknown): State {
    return { message: error instanceof Error ? error.message : String(error) };
  }

  public override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Erreur de rendu', error, info.componentStack);
  }

  public override render(): ReactNode {
    if (this.state.message === null) return this.props.children;
    return (
      <main className="center-page">
        <section className="message-card error-card">
          <p className="eyebrow">Affichage interrompu</p>
          <h1>Cet écran n’a pas pu s’afficher.</h1>
          <p>Les données enregistrées ne sont pas affectées : seul l’affichage a échoué.</p>
          <p className="muted"><code>{this.state.message}</code></p>
          <button className="button primary" onClick={() => window.location.reload()}>Recharger la page</button>
        </section>
      </main>
    );
  }
}
